import * as ambassadorWixLoyaltyReferralV1ReferralEvent from './loyalty-referral-v1-referral-event-tracker.http.js';
import * as ambassadorWixLoyaltyReferralV1ReferralEventTypes from './loyalty-referral-v1-referral-event-tracker.types.js';
import * as ambassadorWixLoyaltyReferralV1ReferralEventUniversalTypes from './loyalty-referral-v1-referral-event-tracker.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getReferralEvent(): __PublicMethodMetaInfo<
  'GET',
  { referralEventId: string },
  ambassadorWixLoyaltyReferralV1ReferralEventUniversalTypes.GetReferralEventRequest,
  ambassadorWixLoyaltyReferralV1ReferralEventTypes.GetReferralEventRequest,
  ambassadorWixLoyaltyReferralV1ReferralEventUniversalTypes.GetReferralEventResponse,
  ambassadorWixLoyaltyReferralV1ReferralEventTypes.GetReferralEventResponse
> {
  const payload = { referralEventId: ':referralEventId' } as any;

  const getRequestOptions =
    ambassadorWixLoyaltyReferralV1ReferralEvent.getReferralEvent(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/referral-events/{referralEventId}',
    pathParams: { referralEventId: 'referralEventId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryReferralEvent(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixLoyaltyReferralV1ReferralEventUniversalTypes.QueryReferralEventRequest,
  ambassadorWixLoyaltyReferralV1ReferralEventTypes.QueryReferralEventRequest,
  ambassadorWixLoyaltyReferralV1ReferralEventUniversalTypes.QueryReferralEventResponse,
  ambassadorWixLoyaltyReferralV1ReferralEventTypes.QueryReferralEventResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyReferralV1ReferralEvent.queryReferralEvent(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/referral-events/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getReferralStatistics(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixLoyaltyReferralV1ReferralEventUniversalTypes.GetReferralStatisticsRequest,
  ambassadorWixLoyaltyReferralV1ReferralEventTypes.GetReferralStatisticsRequest,
  ambassadorWixLoyaltyReferralV1ReferralEventUniversalTypes.GetReferralStatisticsResponse,
  ambassadorWixLoyaltyReferralV1ReferralEventTypes.GetReferralStatisticsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyReferralV1ReferralEvent.getReferralStatistics(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/referral-statistics',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryReferringCustomerTotals(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixLoyaltyReferralV1ReferralEventUniversalTypes.QueryReferringCustomerTotalsRequest,
  ambassadorWixLoyaltyReferralV1ReferralEventTypes.QueryReferringCustomerTotalsRequest,
  ambassadorWixLoyaltyReferralV1ReferralEventUniversalTypes.QueryReferringCustomerTotalsResponse,
  ambassadorWixLoyaltyReferralV1ReferralEventTypes.QueryReferringCustomerTotalsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyReferralV1ReferralEvent.queryReferringCustomerTotals(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/referring-customer-totals/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryReferredFriendActions(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixLoyaltyReferralV1ReferralEventUniversalTypes.QueryReferredFriendActionsRequest,
  ambassadorWixLoyaltyReferralV1ReferralEventTypes.QueryReferredFriendActionsRequest,
  ambassadorWixLoyaltyReferralV1ReferralEventUniversalTypes.QueryReferredFriendActionsResponse,
  ambassadorWixLoyaltyReferralV1ReferralEventTypes.QueryReferredFriendActionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyReferralV1ReferralEvent.queryReferredFriendActions(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/referred-friend-actions/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  ReferralEvent as ReferralEventOriginal,
  ReferralEventEventTypeOneOf as ReferralEventEventTypeOneOfOriginal,
  ReferredFriendSignupEvent as ReferredFriendSignupEventOriginal,
  V1SuccessfulReferralEvent as V1SuccessfulReferralEventOriginal,
  V1ActionEvent as V1ActionEventOriginal,
  V1Trigger as V1TriggerOriginal,
  RewardEvent as RewardEventOriginal,
  RewardEventReceiverOneOf as RewardEventReceiverOneOfOriginal,
  Reward as RewardOriginal,
  RewardWithLiterals as RewardWithLiteralsOriginal,
  CreateReferralEventRequest as CreateReferralEventRequestOriginal,
  CreateReferralEventResponse as CreateReferralEventResponseOriginal,
  GetReferralEventRequest as GetReferralEventRequestOriginal,
  GetReferralEventResponse as GetReferralEventResponseOriginal,
  QueryReferralEventRequest as QueryReferralEventRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryReferralEventResponse as QueryReferralEventResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  GetReferralStatisticsRequest as GetReferralStatisticsRequestOriginal,
  GetReferralStatisticsResponse as GetReferralStatisticsResponseOriginal,
  QueryReferringCustomerTotalsRequest as QueryReferringCustomerTotalsRequestOriginal,
  QueryReferringCustomerTotalsResponse as QueryReferringCustomerTotalsResponseOriginal,
  ReferringCustomerTotal as ReferringCustomerTotalOriginal,
  QueryReferredFriendActionsRequest as QueryReferredFriendActionsRequestOriginal,
  QueryReferredFriendActionsResponse as QueryReferredFriendActionsResponseOriginal,
  ReferredFriendAction as ReferredFriendActionOriginal,
  ReferredFriendActionRewardTypeOptionsOneOf as ReferredFriendActionRewardTypeOptionsOneOfOriginal,
  V1Coupon as V1CouponOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  Coupon as CouponOriginal,
  CouponDiscountTypeOptionsOneOf as CouponDiscountTypeOptionsOneOfOriginal,
  CouponScopeOrMinSubtotalOneOf as CouponScopeOrMinSubtotalOneOfOriginal,
  DiscountType as DiscountTypeOriginal,
  DiscountTypeWithLiterals as DiscountTypeWithLiteralsOriginal,
  FixedAmountDiscount as FixedAmountDiscountOriginal,
  PercentageDiscount as PercentageDiscountOriginal,
  CouponScope as CouponScopeOriginal,
  Group as GroupOriginal,
  LoyaltyPoints as LoyaltyPointsOriginal,
  ReprocessReferralEventsRequest as ReprocessReferralEventsRequestOriginal,
  ReprocessReferralEventsRequestEntityOneOf as ReprocessReferralEventsRequestEntityOneOfOriginal,
  ReprocessReferralEventsResponse as ReprocessReferralEventsResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  SuccessfulReferralEvent as SuccessfulReferralEventOriginal,
  ReferredFriendDetails as ReferredFriendDetailsOriginal,
  ReferredFriendActionEvent as ReferredFriendActionEventOriginal,
  Trigger as TriggerOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './loyalty-referral-v1-referral-event-tracker.types.js';
